import {Component, OnInit} from '@angular/core';
import {NavBarService} from '../../../services/nav-bar/nav-bar.service';
import {User} from '../../../models/User';
import {BaseHttpService} from '../../../services/base-http/base-http.service';
import {TranslatableString} from '../../../models/TranslatableString';
import {MEDIA_URL} from '../../../shared/constants';
import {IUsers} from '../../../services/base-http/IUsers';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss']
})
export class TeamComponent implements OnInit {

  leftUsers: User[];
  rightUsers: User[];

  constructor(private nav: NavBarService, private httpService: BaseHttpService) {
    this.leftUsers = [];
    this.rightUsers = [];
  }

  ngOnInit() {
    this.getUsers();
    setTimeout(() => {
      this.nav.deselectAll();
      this.nav.aboutSelected = true;
      this.nav.teamSelected = true;
    }, 0);
  }

  getUsers(): void {
    this.httpService.getUsers()
      .subscribe((users) => {
        this.leftUsers = [];
        this.rightUsers = [];
        console.log(users);
        for (let i = 0; i < users.length; i++) {
          const user: IUsers = {
            name: new TranslatableString(
              users[i].name,
              users[i].name_en,
              users[i].name_bg,
              users[i].name_ru),

            phoneNumber: users[i].phone_number,
            mobileNumber: users[i].mobile_number,
            email: users[i].email,
            picture: MEDIA_URL + users[i].user_picture,
            workPosition: new TranslatableString(
              users[i].work_position,
              users[i].work_position_en,
              users[i].work_position_bg,
              users[i].work_position_ru),

            birthdate: users[i].birth_date,
            education: new TranslatableString(
              users[i].education,
              users[i].education_en,
              users[i].education_bg,
              users[i].education_ru),

            spokenLanguages: new TranslatableString(
              users[i].spoken_languages,
              users[i].spoken_languages_en,
              users[i].spoken_languages_bg,
              users[i].spoken_languages_ru),

            additionalQualifications: new TranslatableString(
              users[i].additional_qualification,
              users[i].additional_qualification_en,
              users[i].additional_qualification_bg,
              users[i].additional_qualification_ru),

            workingFrom: users[i].working_from_date,
            interests: new TranslatableString(
              users[i].interests,
              users[i].interests_en,
              users[i].interests_bg,
              users[i].interests_ru),

            user_picture: users[i].user_picture
          };
          if (user.workPosition.value.toLowerCase().includes('консултант')) {
            this.rightUsers.push(user);
          } else {
            this.leftUsers.push(user);
          }
        }
        this.swapMembers();
      });
  }

  swapMembers() {
    const user1 = this.rightUsers[0];
    this.rightUsers[0] = this.rightUsers[1];
    this.rightUsers[1] = user1;
  }
}
